import { InfoCircleOutlined } from '@ant-design/icons';
import { Alert } from 'antd';
import moment from 'moment';

import { Stopover as StopoverType } from '../../types';

type StopoverCancelationDataProps = {
  selectedStopover: StopoverType;
};

export function StopoverCancelationData(props: StopoverCancelationDataProps) {
  const { selectedStopover } = props;
  return (
    <div>
      <Alert
        message={
          <>
            <span>
              Escala cancelada em:{' '}
              {moment(selectedStopover.cancelation_date).format(
                'DD/MM/YYYY HH:mm'
              )}
            </span>
            <br />
            <span>Motivo: {selectedStopover.cancelation_motivation}</span>
          </>
        }
        type="warning"
        showIcon
        style={{ margin: '20px' }}
        icon={<InfoCircleOutlined />}
      />
    </div>
  );
}
